import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
  IconButton,
  Paper,
} from "@mui/material";

import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";

/* ================= RISK DECISION DATA ================= */

const riskDecisionRows = [
  {
    id: 1,
    dateTime: "Mar 18, 2024, 2:43 PM",
    decisionId: "156392",
    riskType: "Bulk Price Change",
    vendor: "StyleHub",
    category: "Apparel",
    status: "High Risk",
    score: "76%",
  },
  {
    id: 2,
    dateTime: "Mar 15, 2024, 10:50 AM",
    decisionId: "12801932",
    riskType: "High-Value Luxury Order",
    desc: "Flagged high value order > $5,500",
    vendor: "Rehabatronics",
    category: "Luxury",
    status: "Pending Review",
    score: null,
  },
  {
    id: 3,
    dateTime: "Mar 14, 2024, 5:10 PM",
    decisionId: "12990162",
    riskType: "Suspicious Health Relisting",
    vendor: "Good Grain",
    category: "Grocer",
    status: "High Risk",
    score: "92%",
  },
  {
    id: 4,
    dateTime: "Mar 8, 2024, 3:55 PM",
    decisionId: "195894",
    riskType: "Bulk Price Change",
    vendor: "StyleHub",
    category: "Apparel",
    status: "High Risk",
    score: "81%",
  },
  {
    id: 5,
    dateTime: "Feb 26, 2024, 7:11 PM",
    decisionId: "152806",
    riskType: "Bulk Price Change",
    desc: "Flagged firms under honor code",
    vendor: "Ham Raks",
    category: "Loquat",
    status: "High Risk",
    score: "99%",
  },
  {
    id: 6,
    dateTime: "Feb 15, 2024, 7:10 AM",
    decisionId: "17560",
    riskType: "Bulk Price Change",
    vendor: "StyleHub",
    category: "Apparel",
    status: "High Risk",
    score: "76%",
  },
  {
    id: 7,
    dateTime: "Feb 8, 2024, 2:36 PM",
    decisionId: "12560152",
    riskType: "Bulk Price Change",
    desc: "Flagged high volume error status",
    vendor: "Fresh Bny Venue",
    category: "Grocer",
    status: "High Risk",
    score: "70%",
  },
  {
    id: 8,
    dateTime: "Feb 8, 2024, 8:36 PM",
    decisionId: "12990152",
    riskType: "High-Value Luxury Order",
    vendor: "Rehabatronics",
    category: "Luxury",
    status: "Pending Review",
    score: null,
  },
];

/* ================= COMPONENT ================= */

const RiskDecisionTable = () => {
  return (
    <div className="lt">
      <TableContainer component={Paper} className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr. No.</TableCell>
              <TableCell>Date & Time</TableCell>
              <TableCell>Decision ID</TableCell>
              <TableCell>Risk Type</TableCell>
              <TableCell>Vendor / Category</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {riskDecisionRows.map((row, index) => (
              <TableRow key={row.id} hover>
                {/* SR */}
                <TableCell>{index + 1}.</TableCell>

                {/* DATE */}
                <TableCell>
                  <Typography fontSize={13}>{row.dateTime}</Typography>
                </TableCell>

                {/* DECISION ID */}
                <TableCell>
                  <Chip
                    size="small"
                    icon={<VisibilityOutlinedIcon />}
                    label={row.decisionId}
                  />
                </TableCell>

                {/* RISK TYPE */}
                <TableCell>
                  <Typography fontWeight={500}>
                    {row.riskType}
                  </Typography>
                  {row.desc && (
                    <Typography fontSize={12} color="text.secondary">
                      {row.desc}
                    </Typography>
                  )}
                </TableCell>

                {/* VENDOR */}
                <TableCell>
                  <Typography>{row.vendor}</Typography>
                  <Typography fontSize={12} color="text.secondary">
                    {row.category}
                  </Typography>
                </TableCell>

                {/* STATUS */}
                <TableCell>
                  <Chip
                    size="small"
                    label={row.status}
                    color={
                      row.status === "High Risk" ? "error" : "warning"
                    }
                  />
                </TableCell>

                {/* SCORE */}
                <TableCell>
                  {row.score && (
                    <Chip
                      size="small"
                      label={row.score}
                      color="error"
                      variant="outlined"
                    />
                  )}
                </TableCell>

                {/* ACTION */}
                <TableCell>
                  <Chip
                    size="small"
                    icon={<VisibilityOutlinedIcon />}
                    label="Explain"
                  />
                  <IconButton size="small">
                    <MoreHorizOutlinedIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default RiskDecisionTable;
